import React from 'react';
import { motion } from 'framer-motion';
import { WarningIcon } from './Icons';
export const WarningSection = () => {
  return <section id="warning" className="py-24 bg-white" data-id="element-333">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-334">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-335">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-100 text-red-600 mb-6" data-id="element-336">
            <WarningIcon className="w-8 h-8" data-id="element-337" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-charcoal mb-6 leading-tight" data-id="element-338">
            Is That Palm Tree Over Your Roof One Storm Away From Disaster?
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-339">
            Read this if you own a home in Orange County and have trees, palms,
            or stumps you've been "meaning to deal with" for months...
          </p>
        </motion.div>

        <div className="prose prose-lg max-w-none text-gray-700 space-y-6" data-id="element-340">
          <p data-id="element-341">Most homeowners don't think about their trees.</p>
          <p data-id="element-342">
            They're busy. Life is busy. The trees have been there for years and
            they look fine.
          </p>
          <p className="font-bold text-2xl text-charcoal mt-8 mb-4" data-id="element-343">
            But here's what nobody tells you —
          </p>
          <p data-id="element-344">Trees are deceiving.</p>
          <p data-id="element-345">
            From the outside, a tree can look perfectly healthy while it's
            rotting from the inside. Dead weight building up in a palm canopy
            you haven't trimmed in two years. A root system slowly buckling your
            driveway. A stump in the backyard your kids trip over every weekend.
          </p>
          <p className="font-bold text-xl italic" data-id="element-346">
            And then — a single wind event. A single storm. A single bad day.
          </p>
          <p data-id="element-347">
            And that "fine-looking" tree becomes a $15,000 insurance claim, a
            totaled car, a damaged roof, or worse.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-red-50 border-l-4 border-red-600 p-8 rounded-r-2xl mt-12 shadow-sm" data-id="element-348">
            <h3 className="text-2xl font-bold text-red-800 mb-4 flex items-center gap-3" data-id="element-349">
              <WarningIcon className="w-6 h-6" data-id="element-350" />
              Here's The Part That Should Scare You
            </h3>
            <p className="text-red-900 font-medium mb-4" data-id="element-351">
              When a tree branch falls in this county — whether it hits a car, a
              fence, a neighbor's property, or a person — the liability follows
              the property owner.
            </p>
            <p className="text-red-900 font-black text-xl mb-4" data-id="element-352">
              That means YOU.
            </p>
            <p className="text-red-800" data-id="element-353">
              Insurance companies look for any reason not to pay. And "I didn't
              know it was dangerous" is not a defense they accept.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
};